var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-table"},[_c('b-table',{attrs:{"thead-tr-class":"table-row-head","tbody-tr-class":"table-body-head","bordered":"","items":_vm.items[1],"fields":_vm.items[0]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }